import { DateTime } from "luxon";

export function prepareDisplayOfTimeStamp(inputTimeStamp: Date): string {
  const convertedToLuxon: DateTime = DateTime.fromISO(
    inputTimeStamp.toString(),
    { zone: "utc" }
  );

  const convertedToLocalTime: DateTime = convertedToLuxon.toLocal();
  const formattedTimeStamp: string = convertedToLocalTime.toFormat(
    "dd/MM/yyyy HH:mm:ss"
  );

  return formattedTimeStamp;
}
